import * as React from 'react';
import { UnderwritingTrendResult } from '../../../../types/reporting.type';
import { fetchUnderwritingTrendResult } from '../../../../services/reporting';
import { FunctionComponent, useContext, useEffect } from 'react';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { formatDollar } from '../../../../helpers/formatters';
import Typography from '@mui/material/Typography';
import { Spacing } from '../../../Layout';
import { InstallationProviderContext } from '../../../../application/Providers/Installation';

interface Props {
    locationId: number;
    submissionId: string;
}

const UnderwritingTrendTableBr: FunctionComponent<Props> = (props) => {
    const { locationId, submissionId } = props;
    const installationProvider = useContext(InstallationProviderContext);

    const [underwritingTrendData, setUnderwritingTrendData] = React.useState<UnderwritingTrendResult>(
        {} as UnderwritingTrendResult
    );

    const fetchUnderwritingTrend = async () => {
        const trendResult = await fetchUnderwritingTrendResult(installationProvider, submissionId, locationId);
        setUnderwritingTrendData(trendResult);
    };

    useEffect(() => {
        if (submissionId) {
            fetchUnderwritingTrend();
        }
    }, [submissionId, locationId]);

    const buildUnderwritingTrendTable = (data: UnderwritingTrendResult) => (
        <>
            <Table size={'small'}>
                <TableHead>
                    <TableRow>
                        <TableCell />
                        <TableCell />
                        <TableCell align={'right'}>0-6 mo.</TableCell>
                        <TableCell align={'right'}>6-12 mo.</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow key={data.groupName}>
                        <TableCell>{data.groupName}</TableCell>
                        <TableCell>Bound Rate</TableCell>
                        <TableCell align={'right'}>
                            {data.finalRate6Mo ? formatDollar(data.finalRate6Mo, 3) : 'N/A'}
                        </TableCell>
                        <TableCell align={'right'}>
                            {data.finalRate12Mo ? formatDollar(data.finalRate12Mo, 3) : 'N/A'}
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
            {!data && (
                <>
                    <Spacing height={'12px'} />
                    <Typography>
                        Currently there are no quoted or bound policies contributing to Trends for this location.
                    </Typography>
                </>
            )}
        </>
    );

    return <>{buildUnderwritingTrendTable(underwritingTrendData)}</>;
};

export default UnderwritingTrendTableBr;
